import { render, staticRenderFns } from "./PhoneView.vue?vue&type=template&id=1e0893ce&scoped=true&"
import script from "./PhoneView.vue?vue&type=script&lang=js&"
export * from "./PhoneView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0893ce",
  null
  
)

export default component.exports